import { getEnvHost } from './environment';
import type { Env } from './types';

export const getDefaultHeaders: (env: Env) => HeadersInit = (env) => ({
  'FFF-Auth': 'V1.1',
  Origin: getEnvHost(env),
  'Content-Type': 'application/json; charset=utf-8',
});

export const spaHeaderOptions: Partial<RequestInit> = {
  credentials: 'include',
  redirect: 'manual',
};
